export default class AttributeNotLoadedError extends Error {}
